import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { Button } from "@mui/material";
import { apiVariable } from "../../../api/apiVariable";
import useAuth from "../../../hooks/useAuth";
import StatusSnackbar from "../../General/StatusSnackbar/StatusSnackbar";
import GenericFormPopup from "../../Fleet/GenericFormPopup/GenericFormPopup";
import {
  truckForSaleFieldConfig,
  truckForSaleInitialValues,
} from "../../../formConfigs/Sale/truckForSaleFieldConfig";

const TruckForSalePopup = () => {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const queryClient = useQueryClient();
  const { token } = useAuth();

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };
  const handleSnackbarClose = () => setStatus("idle");

  const mutation = useMutation({
    mutationFn: (data: any) =>
      axios.post(`${apiVariable}/truckSale`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    onSuccess: () => {
      setStatus("success");
      queryClient.invalidateQueries({ queryKey: ["trucksForSale"] });
      handleClose();
    },
    onError: (error: any) => {
      setStatus("error");
      setErrorMessage(error.response.data || "Failed to submit truck");
    },
  });

  const submitHandler = (data: any) => {
    const finalData = {
      ...data,
    };
    mutation.mutate(finalData);
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Add Truck For Sale
      </Button>
      <GenericFormPopup
        formFields={truckForSaleFieldConfig}
        initialValues={truckForSaleInitialValues}
        title="Add Truck For Sale"
        onSubmit={submitHandler}
        open={open}
        onClose={handleClose}
        loading={mutation.isPending}
      />
      <StatusSnackbar
        status={status}
        successMessage={"Truck for sale added successfully"}
        errorMessage={errorMessage}
        handleClose={handleSnackbarClose}
      />
    </>
  );
};

export default TruckForSalePopup;
